import React from 'react';

import { ValueContainerProps, components } from 'react-select';

export const ValueContainer = <T extends { label: string }>({
    children,
    getValue,
    options,
    selectProps,
    ...rest
}: ValueContainerProps<T>) => {
    const value = getValue();

    let title = '';
    if (value.length === 1) title = value[0].label;
    if (value.length === 2) title = value.map((item) => item.label).join(', ');
    if (value.length > 2 && value.length < options.length)
        title = `${value[0].label}, ${value[1].label} & ${value.length - 2} more`;
    if (value.length === options.length && options.length > 0) title = `All (${options.length})`;

    const defaultChildren = React.Children.toArray(children).filter((child: any) =>
        [components.Input, components.Placeholder].includes(child.type),
    );

    return (
        <components.ValueContainer {...rest} getValue={getValue} options={options} selectProps={selectProps}>
            {[title, ...defaultChildren]}
        </components.ValueContainer>
    );
};
